<template>
  <div>
    <div v-if="wantsCoaching">
      <h1 class="c-heading-1">Persoonlijke begeleiding</h1>
      <p>Hartelijk gefeliciteerd met het voortzetten van je future forward traject! Binnenkort krijg je bericht van je Future Forward-coach voor de start van je individueel traject.</p>
    </div>
    <div v-else>
      <h1 class="c-heading-1">Individueel rapport</h1>
      <p>Dankjewel voor het doorlopen van deze FutureForwad Scan. Binnenkort krijg je bericht van je Future Forward-coach met je individueel rapport.</p>
    </div>
    <div class="c-toolbar">
      <navigation-button to="feedback">Geef ons je feedback</navigation-button>
    </div>
  </div>
</template>

<script>
import NavigationButton from '../components/NavigationButton'
export default {
  components: {
    NavigationButton
  },
  computed: {
    wantsCoaching () {
      return this.$store.state.wantsCoaching
    }
  }
}
</script>
